export enum libraryViewModes {
    condensedMode,
    gridLargeMode,
    listMode,
    summaryMode
}
